<template>
  <div id="app">
    <!-- Navbar -->
    <nav class="navbar">
      <!-- Company Name (Desktop View) -->
      <div class="company-name">Hunts End Holdings</div>

      <div class="menu-icon" @click="toggleMenu">☰</div>

      <div :class="['nav-links', { 'show-menu': showMenu }]">
        <!-- Company Name (Mobile View) -->
        <div class="mobile-company-name" v-if="showMenu">Hunts End Holdings</div>
        <a class="nav-item" href="/" @click="closeMenu">Home</a>
        <a class="nav-item" href="/services" @click="closeMenu">Services</a>
        <a class="nav-item" href="/industries" @click="closeMenu">Industries</a>
        <a class="nav-item" href="/contact" @click="closeMenu">Contact</a>
      </div>
    </nav>

    <!-- Main Content -->
    <div class="main-content">
      <router-view />
    </div>

    <!-- Footer -->
    <footer class="footer">
      © 2025 Hunts End Holdings
    </footer>
  </div>
</template>

<script setup>
import { ref } from 'vue';

const showMenu = ref(false);

const toggleMenu = () => {
  showMenu.value = !showMenu.value;
};

const closeMenu = () => {
  showMenu.value = false;
};
</script>

<style scoped>
/* Navbar */
.navbar {
  background: linear-gradient(135deg, #ff9800, #ff5722);
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: white;
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 1000;
}

/* Company Name - Desktop */
.company-name {
  font-size: 1.4rem;
  font-weight: bold;
  text-transform: uppercase;
}

/* Mobile Company Name */
.mobile-company-name {
  font-size: 1.2rem;
  font-weight: bold;
  text-align: center;
  padding: 10px 0;
  width: 100%;
  color: white;
}

/* Menu Icon */
.menu-icon {
  font-size: 24px;
  cursor: pointer;
  display: none;
}

/* Desktop Navigation */
.nav-links {
  display: flex;
  gap: 20px;
}

.nav-item {
  color: white;
  text-decoration: none;
  font-weight: bold;
  transition: opacity 0.3s ease-in-out;
}

.nav-item:hover {
  opacity: 0.8;
}

/* Mobile Navigation */
@media (max-width: 768px) {
  .menu-icon {
    display: block;
  }

  .nav-links {
    display: none;
    flex-direction: column;
    position: absolute;
    top: 60px;
    left: 0;
    width: 100%;
    background: linear-gradient(135deg, #ff9800, #ff5722);
    padding: 10px 0;
  }

  .show-menu {
    display: flex;
  }

  .nav-item {
    padding: 10px 15px;
    text-align: center;
    display: block;
    width: 100%;
  }
}
</style>
